<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="fullscreen"
        :max-width="maxWidth"
        :transition="transition"
        :overlay="!fullscreen"
        scrollable
    >
        <template v-slot:activator="{ on }">
            <v-btn icon fab dark small :color="mode.color" v-on="on">
                <v-icon>{{ mode.icon }}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ mode.action }} Usuário</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="save" :disabled="$v.$invalid || saving" :loading="saving">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field v-model="objUsuario.nome" label="Nome Completo *" required></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field v-model="objUsuario.email" label="Email *" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field v-model="objUsuario.cargo" label="Cargo *" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-autocomplete
                                v-model="objUsuario.perfis"
                                label="Perfil *"
                                :items="['Administrador', 'Funcionário']"
                                multiple
                                filled
                                chips
                                deletable-chips
                                small-chips
                                required
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                :label="'Senha' + (this.mode.action == 'Cadastrar' ? ' *' : '')"
                                v-model="objUsuario.senha"
                                type="password"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                :label="'Confirme a Senha' + (this.mode.action == 'Cadastrar' ? ' *' : '')"
                                v-model="objUsuario.confirmaSenha"
                                type="password"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <small>* Campos obrigatórios</small>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required        } from 'vuelidate/lib/validators';
import Util                from '@/util';
import modalMixin          from '@/mixins/modalMixin';

export default {
    name        : 'UsuariosModal',
    mixins      : [modalMixin, validationMixin],
    validations : {
        objUsuario : {
            nome       : {
                required
            },
            email      : {
                required
            },
            cargo      : {
                required
            },
            perfis     : {
                required
            },
        }
    },
    props       : {
        usuario    : {
            type    : Object,
            default : function () {
                return {
                    nome   : '',
                    email  : '',
                    cargo  : '',
                    perfis : []
                }
            },
        },
        reloadGrid : Function
    },
    methods     : {
        validatePwd() {
            if (this.mode.action == 'Cadastrar' &&
                (this.objUsuario.senha == "" && this.objUsuario.confirmaSenha == "")
            ) {
                return {
                    valid : false,
                    msg   : 'Ao cadastrar, é obrigatório informar a senha.'
                }
            } else if (this.objUsuario.senha !== this.objUsuario.confirmaSenha) {
                return {
                    valid : false,
                    msg   : 'A senha não foi confirmada!'
                }
            } else {
                return {
                    valid : true
                }
            }
        },
        setObjUsuario() {
            if (this.usuario._id) {
                this.objUsuario = JSON.parse(JSON.stringify(this.usuario));
            } else {
                this.resetObjUsuario();
            }
        },
        resetObjUsuario() {
            this.objUsuario = {
                nome   : '',
                email  : '',
                cargo  : '',
                perfis : []
            };
        },
        save() {
            const validatedPwd = this.validatePwd();
            if (validatedPwd.valid) {
                this.saving = true;
                const id = (this.objUsuario._id ? `/${this.objUsuario._id}` : '');
                this.$axios[this.mode.method](`usuarios${id}`, this.objUsuario).then(response => {
                    this.toggleDialog();
                    // this.resetObjUsuario();
                    this.reloadGrid();
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'green',
                        text  : this.mode.snack
                    };
                }).catch(error => {
                    const errorMsg = Util.getErrorMsg(error.response.data);
                    console.error(errorMsg.detailedMsg);
                    // this.toggleDialog();
                    window.getApp.snackbar = {
                        show      : true,
                        color     : 'red',
                        text      : errorMsg.msg
                    };
                }).finally(() => {
                    this.saving = false;
                });
            } else {
                window.getApp.snackbar = {
                    show  : true,
                    color : 'red',
                    text  : validatedPwd.msg
                };
            }
        }
    },
    computed    : {
        id() {
            return this.objUsuario._id;
        },
    },
    data() {
        return {
            objUsuario : {}
        };
    },
    mounted() {
        this.setObjUsuario();
    },
    watch       : {
        dialog(novo, antigo) {
            if (novo) {
                this.setObjUsuario();
            }
        }
    }
};
</script>
